const WEBVIEWER_WARNING = "WebViewer warning: ";
const WEBVIEWER_ERROR = "WebViewer error: ";
const WebViewer = {
  showWarnings: true,
};
const Except = {
  throw(str: string) {
    throw new Error(WEBVIEWER_ERROR + str);
  },
  error(str: string) {
    console.error(WEBVIEWER_ERROR + str);
  },
  warn(str: string) {
    if (!WebViewer.showWarnings) {
      return;
    }
    console.warn(WEBVIEWER_WARNING + str);
  },
};

export default Except;
